import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const ProtectedRoute = ({ children, requiredRole = null, allowedRoles = null }) => {
  const { userRole, loading, isAdmin, isTechnician, isAdminOrTechnician } = useUser();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Check if user has the required role
  if (requiredRole) {
    switch (requiredRole) {
      case 'Admin':
        if (!isAdmin()) {
          return <Navigate to="/dashboard" replace />;
        }
        break;
      case 'Technician':
        if (!isTechnician()) {
          return <Navigate to="/dashboard" replace />;
        }
        break;
      case 'AdminOrTechnician':
        if (!isAdminOrTechnician()) {
          return <Navigate to="/dashboard" replace />;
        }
        break;
      default:
        break;
    }
  }

  // Check if user has any of the allowed roles
  if (allowedRoles && allowedRoles.length > 0) {
    const hasAllowedRole = allowedRoles.some(role => {
      switch (role) {
        case 'Admin':
          return isAdmin();
        case 'Technician':
          return isTechnician();
        case 'User':
          return userRole === 'User';
        default:
          return false;
      }
    });

    if (!hasAllowedRole) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
